module.exports = __webpack_public_path__ + "crib_ios_qr.1c933c0.png";